import { useCallback, useMemo, useState } from "react";
import clsx from "clsx";
const images = [
  { src: "/images/Hiru/public_images/DJI_0950-Enhanced-NR-Pano-1-copy.webp", category: ["All", "Resort"] },
  { src: "/images/Hiru/public_images/BBC70E26-89D8-475D-A68B-CA85A81C2953.webp", category: ["All", "Resort"] },
  { src: "/images/Hiru/public_images/680A2401-Enhanced-NR-2-Edit-copy.webp", category: ["All", "Ayurveda"] },
  { src: "/images/Hiru/public_images/680A2495-Enhanced-NR-Edit-copy.webp", category: ["All", "Ayurveda"] },
  { src: "/images/Hiru/public_images/steptodown.com380327-e1734531775179.avif", category: ["All", "Beach"] },
  { src: "/images/Hiru/public_images/eyJidWNrZXQiOiJmaXRyZWlzZW4tY2RuLWltYWdlcyIsImtleSI6IkMyNEI1NEI1QjgwODc1MEZEODg0QzkzOEU1RjE4RkZEIiwiZWRpdHMiOnsicmVzaXplIjp7IndpZHRoIjoxMjAwLCJoZWlnaHQiOjkwMCwiZml0IjoiY292ZXIiLCJwb3NpdGlvbiI6ImF0dGVudGlvbiJ9fX0=.webp", category: ["All", "Beach"] },
  { src: "/images/Hiru/public_images/51.webp", category: ["All", "Activities"] },
  { src: "/images/Hiru/public_images/466139159_9094298513916361_4103332598842251054_n.avif", category: ["All", "Activities"] },
  { src: "/images/Hiru/Hiru Villa's/Hiru Om/DRONE/DJI_0967-HDR-Edit-copy.webp", category: ["All", "Resort"] },
  { src: "/images/Hiru/Hiru Villa's/Hiru Om/DOCTOR & AYURVEDA/DSC09186-Edit-copy.webp", category: ["All", "Ayurveda"] },
  { src: "/images/Hiru/Hiru Villa's/Drone/DJI_0947-Enhanced-NR-Pano-copy.webp", category: ["All", "Beach"] },
  { src: "/images/Hiru/IMG_4272-e1734079223142.webp", category: ["All", "Activities"] },
  { src: "/images/Hiru/Hiru Villa's/Hiru Om/RECEPTION & FRONT/680A1151-copy.webp", category: ["All", "Resort"] },
  { src: "/images/Hiru/Hiru Villa's/Hiru Om/DOCTOR & AYURVEDA/680A2487-Enhanced-NR-copy.webp", category: ["All", "Ayurveda"] },
  { src: "/images/Hiru/Hiru Villa's/Hiru Om/GARDEN & DETAILS/680A2506.webp", category: ["All", "Beach"] }
];
const categories = ["All", "Resort", "Ayurveda", "Beach", "Activities"];
const categoryLabels = {
  All: "Alle",
  Resort: "Resort",
  Ayurveda: "Ayurveda",
  Beach: "Strand",
  Activities: "Aktivit\xE4ten"
};
const GallerySection = () => {
  const [active, setActive] = useState("All");
  const [modalImg, setModalImg] = useState(null);
  const filtered = useMemo(
    () => active === "All" ? images : images.filter((img) => img.category.includes(active)),
    [active]
  );
  const handleCloseModal = useCallback(() => {
    setModalImg(null);
  }, []);
  return <section className="w-full bg-gradient-to-b from-white via-[#f8f5f1] to-white py-16 sm:py-20 lg:py-28">
    <div className="container mx-auto px-4 ">
      <h2 className="text-center font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-[#1f4d3c] mb-6 sm:mb-8">
        Fotogalerie
      </h2>
      <div className="flex justify-center gap-2 sm:gap-3 md:gap-4 mb-8 sm:mb-10 flex-wrap px-2">
        {categories.map((cat) => <button
          key={cat}
          className={clsx(
            "px-3 sm:px-5 md:px-6 py-1.5 sm:py-2 rounded-full font-semibold border transition-all shadow-sm text-sm sm:text-base",
            active === cat ? "bg-gradient-to-r from-[#F28600] to-[#ff9a1f] text-white border-[#f28600] shadow-[0_18px_50px_-22px_rgba(242,134,0,0.9)]" : "bg-white text-[#f28600] border-[#f28600]/35 hover:bg-[#fff3e2] hover:border-[#f28600]/60"
          )}
          onClick={() => setActive(cat)}
        >
          {categoryLabels[cat]}
        </button>)}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-5 lg:gap-6">
        {filtered.map((img, idx) => <div
          key={idx}
          className="overflow-hidden rounded-xl sm:rounded-2xl shadow-md sm:shadow-lg relative cursor-pointer group transition-transform duration-300 hover:shadow-xl hover:scale-105"
          onClick={() => setModalImg(img.src)}
        >
          <img
            src={img.src}
            alt={`Fotogalerie, ${categoryLabels[img.category.find((category) => category !== "All")]}, Aufnahme ${idx + 1}`}
            className="w-full h-64 sm:h-80 md:h-96 object-cover group-hover:scale-110 transition-transform duration-300"
            width={400}
            height={256}
            loading="lazy"
          />
        </div>)}
      </div>
      {
        /* Modal for full image */
      }
      {modalImg && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4" onClick={handleCloseModal}>
        <div className="relative max-w-2xl sm:max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
          <button
            className="absolute -top-10 sm:top-2 right-2 sm:right-2 bg-white rounded-full p-2 shadow text-black hover:bg-gray-200 z-10 w-10 h-10 flex items-center justify-center"
            onClick={handleCloseModal}
            aria-label="Schließen"
          >
            &#10005;
          </button>
          <div className="flex items-center justify-center bg-black/30 rounded-lg sm:rounded-2xl overflow-hidden">
            <img
              src={modalImg}
              alt="Ansicht in voller Größe"
              width={900}
              height={600}
              className="rounded-lg sm:rounded-2xl max-h-[75vh] sm:max-h-[80vh] w-auto h-auto" loading="lazy" />
          </div>
        </div>
      </div>}
    </div>
  </section>;
};
export default GallerySection;
